import { render, staticRenderFns } from "./iFileUpload.vue?vue&type=template&id=1bbd456f&scoped=true&"
import script from "./iFileUpload.vue?vue&type=script&lang=js&"
export * from "./iFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./iFileUpload.vue?vue&type=style&index=0&id=1bbd456f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd456f",
  null
  
)

export default component.exports